const TagIcon = (props) => {
    return (
        <svg
          width={10}
          height={10}
          viewBox="0 0 15 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            d="M3.438 4.375a.937.937 0 110-1.875.937.937 0 010 1.875zm9.943 2.862L7.756 1.612a1.242 1.242 0 00-.881-.362H2.5c-.694 0-1.25.556-1.25 1.25v4.375c0 .344.137.656.369.881l5.619 5.625c.23.225.543.369.887.369s.656-.144.881-.369l4.375-4.375c.232-.225.369-.537.369-.881 0-.35-.144-.662-.369-.888z"
            fill="#FF4F69"
          />
        </svg>
      )
}

export default TagIcon